import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\BillingController::index
* @see Http/Controllers/BillingController.php:30
* @route '/billing'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/billing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BillingController::index
* @see Http/Controllers/BillingController.php:30
* @route '/billing'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BillingController::index
* @see Http/Controllers/BillingController.php:30
* @route '/billing'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BillingController::index
* @see Http/Controllers/BillingController.php:30
* @route '/billing'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\BillingController::index
* @see Http/Controllers/BillingController.php:30
* @route '/billing'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BillingController::index
* @see Http/Controllers/BillingController.php:30
* @route '/billing'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BillingController::index
* @see Http/Controllers/BillingController.php:30
* @route '/billing'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\BillingController::status
* @see Http/Controllers/BillingController.php:53
* @route '/billing/status'
*/
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/billing/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BillingController::status
* @see Http/Controllers/BillingController.php:53
* @route '/billing/status'
*/
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BillingController::status
* @see Http/Controllers/BillingController.php:53
* @route '/billing/status'
*/
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BillingController::status
* @see Http/Controllers/BillingController.php:53
* @route '/billing/status'
*/
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\BillingController::status
* @see Http/Controllers/BillingController.php:53
* @route '/billing/status'
*/
const statusForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BillingController::status
* @see Http/Controllers/BillingController.php:53
* @route '/billing/status'
*/
statusForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BillingController::status
* @see Http/Controllers/BillingController.php:53
* @route '/billing/status'
*/
statusForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: status.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

status.form = statusForm

/**
* @see \App\Http\Controllers\BillingController::checkoutSession
* @see Http/Controllers/BillingController.php:118
* @route '/billing/checkout-session'
*/
export const checkoutSession = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkoutSession.url(options),
    method: 'post',
})

checkoutSession.definition = {
    methods: ["post"],
    url: '/billing/checkout-session',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BillingController::checkoutSession
* @see Http/Controllers/BillingController.php:118
* @route '/billing/checkout-session'
*/
checkoutSession.url = (options?: RouteQueryOptions) => {
    return checkoutSession.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BillingController::checkoutSession
* @see Http/Controllers/BillingController.php:118
* @route '/billing/checkout-session'
*/
checkoutSession.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkoutSession.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BillingController::checkoutSession
* @see Http/Controllers/BillingController.php:118
* @route '/billing/checkout-session'
*/
const checkoutSessionForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkoutSession.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BillingController::checkoutSession
* @see Http/Controllers/BillingController.php:118
* @route '/billing/checkout-session'
*/
checkoutSessionForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkoutSession.url(options),
    method: 'post',
})

checkoutSession.form = checkoutSessionForm

/**
* @see \App\Http\Controllers\BillingController::portal
* @see Http/Controllers/BillingController.php:141
* @route '/billing/portal'
*/
export const portal = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: portal.url(options),
    method: 'post',
})

portal.definition = {
    methods: ["post"],
    url: '/billing/portal',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\BillingController::portal
* @see Http/Controllers/BillingController.php:141
* @route '/billing/portal'
*/
portal.url = (options?: RouteQueryOptions) => {
    return portal.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BillingController::portal
* @see Http/Controllers/BillingController.php:141
* @route '/billing/portal'
*/
portal.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: portal.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BillingController::portal
* @see Http/Controllers/BillingController.php:141
* @route '/billing/portal'
*/
const portalForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: portal.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\BillingController::portal
* @see Http/Controllers/BillingController.php:141
* @route '/billing/portal'
*/
portalForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: portal.url(options),
    method: 'post',
})

portal.form = portalForm

/**
* @see \App\Http\Controllers\StripeWebhookController::webhook
* @see Http/Controllers/StripeWebhookController.php:21
* @route '/billing/webhook'
*/
export const webhook = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: webhook.url(options),
    method: 'post',
})

webhook.definition = {
    methods: ["post"],
    url: '/billing/webhook',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\StripeWebhookController::webhook
* @see Http/Controllers/StripeWebhookController.php:21
* @route '/billing/webhook'
*/
webhook.url = (options?: RouteQueryOptions) => {
    return webhook.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\StripeWebhookController::webhook
* @see Http/Controllers/StripeWebhookController.php:21
* @route '/billing/webhook'
*/
webhook.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: webhook.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\StripeWebhookController::webhook
* @see Http/Controllers/StripeWebhookController.php:21
* @route '/billing/webhook'
*/
const webhookForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: webhook.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\StripeWebhookController::webhook
* @see Http/Controllers/StripeWebhookController.php:21
* @route '/billing/webhook'
*/
webhookForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: webhook.url(options),
    method: 'post',
})

webhook.form = webhookForm

const billing = {
    index: Object.assign(index, index),
    status: Object.assign(status, status),
    checkoutSession: Object.assign(checkoutSession, checkoutSession),
    portal: Object.assign(portal, portal),
    webhook: Object.assign(webhook, webhook),
}

export default billing